var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Lottie',{attrs:{"options":_vm.animationOptions},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }